"use client";

import { useCallback } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { Button } from "@stone-payments/jade";
import { useFilters } from "@/contexts/filters-provider";
import { buildQueryString } from "@/utils/url";
import { storeAnalitica } from "@/app/(store)/_utils/events";

export const FiltersClear = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { setIsFiltering, categoryId, setCategoryId, order, setOrder } =
    useFilters();

  const handleClearFilters = useCallback(() => {
    const { queryString } = buildQueryString({
      ...Object.fromEntries(searchParams),
      categoria: null,
      ordenar: null,
    });

    setIsFiltering(true);
    setCategoryId(null);
    setOrder(null);

    storeAnalitica.events.action.clearFiltersClicked();

    router.push(queryString);
  }, [router, searchParams, setIsFiltering, setCategoryId, setOrder]);

  return (
    <Button
      data-testid="filters-clear-button"
      variant="neutral-ghost"
      size="medium"
      disabled={!categoryId && !order}
      onClick={handleClearFilters}
    >
      Limpar todos
    </Button>
  );
};
